import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import   { persistor, store } from './app/store';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';
import { FooterSimple}  from './components/FooterSimple';
import { PersistGate } from 'redux-persist/integration/react';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
            </Helmet>
            <App />
        </PersistGate>
    </Provider>
);
